import { cn } from '@magicdoorinc/ui';
import { Show } from 'solid-js';
import { emptyPlaceholder } from '~/utils/constant';
import type { AddressDto } from '~/swagger/portal/Api';

interface DisplayAddressProps {
  class?: string;
  address?: AddressDto | null;
  singleLineAddress?: string;
}

const DisplayAddress = (props: DisplayAddressProps) => {
  return (
    <div class={cn('w-full text-wrap', props.class)}>
      <Show when={!props.singleLineAddress} fallback={props.singleLineAddress}>
        <Show when={props.address && props.address?.streetAddress1} fallback={emptyPlaceholder}>
          {props.address?.streetAddress1}, <Show when={props.address?.streetAddress2}>#{props.address?.streetAddress2}, </Show>
          {props.address?.city}, {props.address?.state} {props.address?.zipCode}
        </Show>
      </Show>
    </div>
  );
};

export default DisplayAddress;
